import React from 'react';

const ToggleSwitch = ({ checked, onChange, label }) => {
  return (
    <div className="flex items-start sm:items-center justify-between gap-4 py-5 border-t border-[#1a2238] mt-6">
      <div className="flex-1">
        <label
          className="text-sm sm:text-base font-medium text-slate-200 cursor-pointer select-none font-inter"
          onClick={() => onChange(!checked)}
        >
          {label}
        </label>
        <p className="text-xs text-slate-400 mt-1 font-inter">
          Avg. value jumps from{' '}
          <span className="text-slate-300 font-semibold">$4,750</span> to{' '}
          <span className="text-[#00E5FF] font-semibold">$11,250</span>
        </p>
      </div>

      <button
        type="button"
        role="switch"
        aria-checked={checked}
        onClick={() => onChange(!checked)}
        className={`relative inline-flex h-8 w-14 flex-shrink-0 cursor-pointer rounded-full border-2 transition-colors duration-200 ease-in-out focus:outline-none ${
          checked ? 'bg-[#00E5FF] border-[#00E5FF]' : 'bg-[#1a2238] border-[#1a2238]'
        }`}
      >
        <span
          aria-hidden="true"
          className={`pointer-events-none inline-block h-7 w-7 transform rounded-full shadow ring-0 transition duration-200 ease-in-out ${
            checked ? 'translate-x-6 bg-[#060c1a]' : 'translate-x-0 bg-slate-400'
          }`}
        />
      </button>
    </div>
  );
};

export default ToggleSwitch;